(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) :
    typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
    (factory((global.reactArcgisHub = {}),null));
}(this, (function (exports,React) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    function isEmberIntl(intl) {
        return !!intl.t;
    }
    // emulating the ember-intl t() API in React
    function t(message, intl, values, formats) {
        if (!intl) {
            // no intl, just return the message
            return message;
        }
        // both react-intl and ember-intl expose .formatMessage(), but they work differently
        // https://github.com/yahoo/react-intl/wiki/API#formatmessage
        // https://github.com/ember-intl/ember-intl/blob/2.x/docs/ember-service-api.md#methods
        // ember-intl's t() is closer to react-intl's formatMessage()
        if (isEmberIntl(intl)) {
            // we are in Ember, pass all arguments (including formatting options) to t()
            return intl.t(message, values, formats);
        }
        else {
            // we are in react, pass a MessageDescriptor-like object and values to formatMessage()
            return intl.formatMessage({ id: message }, values);
        }
    }

    var HubAuthButtons = /** @class */ (function (_super) {
        __extends(HubAuthButtons, _super);
        function HubAuthButtons() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        HubAuthButtons.prototype.onButtonClick = function (provider) {
            if (typeof this.props.onSignIn === 'function') {
                this.props.onSignIn(provider);
            }
        };
        HubAuthButtons.prototype.render = function () {
            var _this = this;
            var intl = this.props.intl;
            return React.createElement("div", null,
                React.createElement("button", { onClick: function () { return _this.onButtonClick('facebook'); }, className: "btn btn-block btn-social btn-facebook" },
                    React.createElement("img", { src: "//d1iq7pbacwn5rb.cloudfront.net/opendata-ui/assets/assets/images/facebook_btn-cece4e56a57496bc2da4c62d8fbd691d.png", alt: "" }),
                    " ",
                    t('arcgisHub.HubAuthButtons.withFacebook', intl)),
                React.createElement("button", { onClick: function () { return _this.onButtonClick('google'); }, className: "btn btn-block btn-social btn-google" },
                    React.createElement("img", { src: "//d1iq7pbacwn5rb.cloudfront.net/opendata-ui/assets/assets/images/google_btn-8b7e21aaa900e1cb388760f964bb0b5b.png", alt: "" }),
                    " ",
                    t('arcgisHub.HubAuthButtons.withGoogle', intl)),
                React.createElement("button", { onClick: function () { return _this.onButtonClick(); }, className: "btn btn-block btn-social btn-ago" },
                    React.createElement("img", { src: "//d1iq7pbacwn5rb.cloudfront.net/opendata-ui/assets/assets/images/bank-34bcd4a0cb3cf2f66d6161f95a3be3d0.png", alt: "" }),
                    " ",
                    t('arcgisHub.HubAuthButtons.withOrganization', intl)));
        };
        return HubAuthButtons;
    }(React.Component));

    var ItemPager = function (_a) {
        var pageSize = _a.pageSize, totalCount = _a.totalCount, pageNumber = _a.pageNumber, changePage = _a.changePage, intl = _a.intl;
        var totalPages = Math.ceil(totalCount / pageSize);
        if (!totalPages || totalPages < 2) {
            // don't show pagination
            return null;
        }
        // get the range of pages to show
        var currentPage = pageNumber;
        var start = totalPages > 10 && currentPage > 6 ? currentPage - 5 : 1;
        var end = totalPages > start + 9 ? start + 9 : totalPages;
        var isFirstPage = currentPage === 1;
        var lastPage = totalPages;
        var isLastPage = pageNumber >= lastPage;
        // generate links for each page in the range
        var pageLinks = [];
        for (var i = start; i <= end; i++) {
            pageLinks.push(React.createElement(PageItem, { pageNumber: i, currentPage: currentPage, changePage: changePage, key: i }, i));
        }
        return (React.createElement("ul", { className: "pagination" },
            React.createElement(PageItem, { pageNumber: 1, currentPage: currentPage, changePage: changePage, key: "\u00AB", label: t('arcgisHub.ItemPager.firstPage', intl), disabled: isFirstPage }, "\u00AB"),
            React.createElement(PageItem, { pageNumber: currentPage - 1, currentPage: currentPage, changePage: changePage, key: "\u2039", label: t('arcgisHub.ItemPager.previousPage', intl), disabled: isFirstPage }, "\u2039"),
            pageLinks,
            React.createElement(PageItem, { pageNumber: currentPage + 1, currentPage: currentPage, changePage: changePage, key: "\u203A", label: t('arcgisHub.ItemPager.nextPage', intl), disabled: isLastPage }, "\u203A"),
            React.createElement(PageItem, { pageNumber: lastPage, currentPage: currentPage, changePage: changePage, key: "\u00BB", label: t('arcgisHub.ItemPager.lastPage', intl), disabled: isLastPage }, "\u00BB")));
    };
    var PageItem = /** @class */ (function (_super) {
        __extends(PageItem, _super);
        function PageItem() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.onClick = function (e) {
                e.preventDefault();
                var _a = _this.props, changePage = _a.changePage, disabled = _a.disabled, pageNumber = _a.pageNumber;
                if (!disabled && changePage) {
                    changePage(pageNumber);
                }
            };
            return _this;
        }
        PageItem.prototype.render = function () {
            var _a = this.props, currentPage = _a.currentPage, disabled = _a.disabled, pageNumber = _a.pageNumber, label = _a.label;
            var isActive = !disabled && pageNumber === currentPage;
            var className = "page-item" + (isActive && ' active');
            var ariaLabel = disabled ? 'disabled' : label || "Page " + pageNumber;
            return (React.createElement("li", { className: className },
                React.createElement("a", { className: "page-link", href: "", onClick: this.onClick, "aria-label": ariaLabel }, this.props.children)));
        };
        return PageItem;
    }(React.Component));

    exports.HubAuthButtons = HubAuthButtons;
    exports.ItemPager = ItemPager;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=react-arcgis-hub.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/umd/react-arcgis-hub.js
// module id = 48
// module chunks = 0